<template>
  <!-- 选择城市和机构 -->
  <div style="display: inline-block">
    <el-select
      clearable
      class="mgr-20 input"
      v-model="searchData.buildingId"
      size="small"
      placeholder="请选择楼栋"
      @change="selectCityChange"
    >
      <el-option
        v-for="i in cityList"
        :key="i.id"
        :label="i.branchName + i.buildingNo"
        :value="i.id"
      ></el-option>
    </el-select>
    <el-select
      clearable
      :disabled="!searchData.buildingId"
      class="mgr-20 input"
      v-model="searchData.floorId"
      size="small"
      placeholder="请选择楼层"
      @change="selectMechanism"
    >
      <el-option
        v-for="i in mechanismList"
        :key="i.id"
        :label="i.floorNo"
        :value="i.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { getCityAndMechanism } from "@/api/service";
export default {
  props: {
    isDefaultValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchData: {
        buildingId: "", // 楼栋id
        floorId: "", // 楼层id
      },
      cityList: [], // 城市列表
      mechanismList: [], //  机构列表
    };
  },
  created() {
    this.getCityAndMechanismFunc(); //  获取城市列表
  },
  methods: {
    //  获取城市列表
    async getCityAndMechanismFunc() {
      let res = await getCityAndMechanism({ branchId: 6627 });
      this.cityList = JSON.parse(JSON.stringify(res.data.data.rows));
      this.mechanismList = this.cityList[0].floorList;
      this.searchData.buildingId = (this.cityList && this.cityList[0].id) || "";
      this.$emit(
        "update:buildingId",
        (this.cityList && this.cityList[0].id) || ""
      );
      this.$emit(
        "update:branchId",
        (this.cityList && this.cityList[0].branchId) || ""
      );
      this.searchData.floorId =
        (this.cityList &&
          this.cityList[0].floorList[0] &&
          this.cityList[0].floorList[0].id) ||
        "";
      this.$emit(
        "update:floorId",
        (this.cityList &&
          this.cityList[0].floorList[0] &&
          this.cityList[0].floorList[0].id) ||
          ""
      );
    },
    selectCityChange() {
      this.$emit("update:buildingId", this.searchData.buildingId);
      this.searchData.floorId = "";
      if (!this.searchData.buildingId) {
        return;
      }
      let index = this.cityList.findIndex(
        (i) => i.id === this.searchData.buildingId
      );
      this.mechanismList = this.cityList[index].floorList;
    },
    // 选择机构改变
    selectMechanism() {
      this.$emit("update:floorId", this.searchData.floorId);
    },
  },
};
</script>

<style>
.mgr-20 {
  margin-right: 20px;
}

.input {
  width: 180px !important;
}
</style>
